import { datadogLogs } from '@datadog/browser-logs';

export const safeTrackEventDD = (
  name: string,
  properties?: Record<string, unknown>,
): void => {
  try {
    datadogLogs.logger.info(name, properties);
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error(`Datadog log failed: ${name}`, {
        error: err as Error,
        properties,
      });
    }
  }
};
